<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionAssetContentsDropDownSearch"
  >
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li
          v-for="resultado in resultados"
          :key="resultado.id"
        >
          <a
            href="#"
            @click.prevent="goToNode(resultado)"
          >
            <span class="ellipsis m-dropdown-item-text">
              {{ resultado.nombre }}
            </span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsDropDownSearch',

  props: {
    resultados: Array
  },

  methods: {
    goToNode (nodo) {
      this.$store.commit('setAssetSelectedNode', nodo)
      this.$dropDown.closeDropDown('MoleculeEditionAssetContentsDropDownSearch')
    }
  }
}
</script>
